import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['isPlus', 'userInfo'])
  },
  methods: {
    async getRealidcation() {
      /* 0: 不跳
         1：项目首页
         2：cp下载页
         3：代理下载页
         4: 返回app内首页 */
      const res = await this.$store.dispatch('getRealidcation', { jump: this.isPlus ? 4 : (this.userInfo.is_agent ? 3 : 2) })
      if (res.code === 1) {
        return res.data
      }
      return null
    }
  }
}
